import {MouseEvent, PureComponent} from 'react';
import { connect } from 'react-redux';
import {Dispatch} from 'redux';

import DesktopDeliveryMenuComponent from 'Component/DesktopDeliveryMenu/DesktopDeliveryMenu.component';
import {deliveryDateWeekday} from 'Query/MyAccount.type';
import {CUSTOMER} from 'Route/MyAccount/MyAccount.config';
import MyAccountCompanyDispatcher from 'Store/MyAccountCompany/MyAccountCompany.dispatcher';
import BrowserDatabase from 'Util/BrowserDatabase';
import {getNearestDateByWeekday} from 'Util/DesktopDeliveryMenu';
import { RootState } from 'Util/Store/Store.type';

import {
    DesktopDeliveryMenuContainerFunctions,
    DesktopDeliveryMenuContainerMapStateProps,
    DesktopDeliveryMenuContainerProps,
    DesktopDeliveryMenuContainerState,
} from './DesktopDeliveryMenu.type';

/** @namespace Steinkrueger/Component/DesktopDeliveryMenu/Container/mapStateToProps */
export const mapStateToProps = (state: RootState): DesktopDeliveryMenuContainerMapStateProps => ({
    selectedDeliveryDay: state.MyAccountCompanyReducer.selectedDeliveryDay,
    device: state.ConfigReducer.device,
});

/** @namespace Steinkrueger/Component/DesktopDeliveryMenu/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch: Dispatch) => ({
    setSelectedDeliveryDay: (date: string) => MyAccountCompanyDispatcher.setSelectedDeliveryDay(dispatch, date),
    setPreSelectedDeliveryDay: (date: string) => MyAccountCompanyDispatcher.setPreSelectedDeliveryDay(dispatch, date),
    getSelectedDeliveryDay: () => MyAccountCompanyDispatcher.getSelectedDeliveryDay(dispatch),
});

/** @namespace Steinkrueger/Component/DesktopDeliveryMenu/Container */
export class DesktopDeliveryMenuContainer extends PureComponent<
DesktopDeliveryMenuContainerProps,
DesktopDeliveryMenuContainerState> {
    containerFunctions: DesktopDeliveryMenuContainerFunctions = {
        handleDeliveryDate: this.handleDeliveryDate.bind(this),
    };

    __construct(): void {
        this.state = {
            deliveryDateWeekday: [],
        };
    }

    componentDidMount() {
        const { getSelectedDeliveryDay } = this.props;
        this.createAvailableDeliveryDates();
        getSelectedDeliveryDay();
    }

    componentDidUpdate() {
        const { deliveryDateWeekday } = this.state;
        const { delivery_date_weekday }: {
            delivery_date_weekday?: deliveryDateWeekday[];
        } = BrowserDatabase.getItem(CUSTOMER) || {};

        if (!deliveryDateWeekday.length && delivery_date_weekday) {
            this.createAvailableDeliveryDates();
        }
    }

    createAvailableDeliveryDates(): void {
        const { delivery_date_weekday, delivery_date }: {
            delivery_date_weekday?: deliveryDateWeekday[];
            delivery_date?: string;
        } = BrowserDatabase.getItem(CUSTOMER) || {};

        const { selectedDeliveryDay, setPreSelectedDeliveryDay } = this.props;

        const formattedDeliveryDatesArray = delivery_date_weekday ? delivery_date_weekday.map((item) => {
            // eslint-disable-next-line no-param-reassign
            item.weekday = getNearestDateByWeekday(item.weekday);

            return item;
        }) : [];

        formattedDeliveryDatesArray.sort((a, b) => Date.parse(a.weekday.toString()) - Date.parse(b.weekday.toString()));

        const firstAvailableDeliveryDate = formattedDeliveryDatesArray.find((item) => item.is_available);

        if (!selectedDeliveryDay && firstAvailableDeliveryDate) {
            const customerDeliveryDate = delivery_date ? new Date(delivery_date) : new Date();
            const today = new Date();

            if (today < customerDeliveryDate) {
                setPreSelectedDeliveryDay(delivery_date || firstAvailableDeliveryDate.weekday.toString());
            } else {
                setPreSelectedDeliveryDay(firstAvailableDeliveryDate.weekday.toString());
            }
        }

        this.setState({deliveryDateWeekday: formattedDeliveryDatesArray || []});
    }

    handleDeliveryDate(e: MouseEvent, date: string) {
        e.stopPropagation();
        e.preventDefault();

        const { setSelectedDeliveryDay } = this.props;

        setSelectedDeliveryDay(date);
    }

    containerProps() {
        const {
            onAvailableDateMenuClick,
            opened,
            selectedDeliveryDay,
            device: {
                isMobile,
            },
        } = this.props;

        const {
            deliveryDateWeekday,
        } = this.state;

        return {
            onAvailableDateMenuClick,
            selectedDeliveryDay,
            deliveryDateWeekday,
            opened,
            isMobile,
        };
    }

    render() {
        return (
            <DesktopDeliveryMenuComponent
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DesktopDeliveryMenuContainer);
